import { SVGProps } from '@components/Icon/types';

export const Desktop = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 3)">
      <path
        d="M16 0C18.14 0 19.8879 1.68056 19.9951 3.79395L20 4V10L19.9951 10.2061C19.8913 12.2512 18.2512 13.8913 16.2061 13.9951L16 14H13.2002V16.2998H14C14.3866 16.2998 14.7002 16.6134 14.7002 17C14.7002 17.3866 14.3866 17.7002 14 17.7002H6C5.6134 17.7002 5.2998 17.3866 5.2998 17C5.2998 16.6134 5.6134 16.2998 6 16.2998H6.7998V14H4C1.79086 14 9.66384e-08 12.2091 0 10V4C0 1.79086 1.79086 3.22133e-08 4 0H16ZM8.2002 16.2998H11.7998V14.1006H8.2002V16.2998ZM4 1.40039C2.56406 1.40039 1.40039 2.56406 1.40039 4V10C1.40039 11.4359 2.56406 12.5996 4 12.5996H16C17.4359 12.5996 18.5996 11.4359 18.5996 10V4C18.5996 2.56406 17.4359 1.40039 16 1.40039H4Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'desktop';
